<template>
  <div>
    <select
      class="form-control"
      @change="onChanged($event)"
      :disabled="disabled"
    >
      <option value="-1" :selected="selectedVal == -1"
        >---{{ $t("messages.general.notSpecified") }}---</option
      >
      <option
        v-for="(item, index) in items"
        :key="index"
        :value="item.TYPEID"
        :selected="selectedVal == item.TYPEID"
      >
        {{ item.TYPENAME }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import EnrollProvider from "@/services/enroll_provider";

const enrollProvider = new EnrollProvider();

export default {
  name: "TYPE",
  props: {
    onChanged: Function,
    selectedVal: Number,
    disabled: { type: Boolean, default: true }
  },
  data: () => {
    return {
      items: []
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    ...mapActions("application", ["togglePreLoader"]),
    async loadData() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getconditionlist({
        token: this.token,
        request: {
          lang: this.currentLang,
        },
      });
      if (result.length > 0) {
        this.items = result.map(r => {
          return {
            TYPEID: r.ERRORID,
            TYPENAME: r.ERRORID
          }
        })
      }
      // this.items = [
      //   { TYPEID: 4001, TYPENAME: "4001" },
      //   { TYPEID: 4002, TYPENAME: "4002" },
      //   { TYPEID: 4003, TYPENAME: "4003" }
      // ];
      this.togglePreLoader(false);
    }
  },
  watch: {
    currentLang() {
      this.loadData();
    }
  }
};
</script>
